import React, { useState } from 'react';
import { 
  Paper, 
  BottomNavigation, 
  BottomNavigationAction
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Icons
import HomeIcon from '@mui/icons-material/Home';
import ScanIcon from '@mui/icons-material/QrCodeScanner';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import NewsIcon from '@mui/icons-material/Article';
import StoreIcon from '@mui/icons-material/Store';

const BottomBar = () => {
  const location = useLocation();
  const { isAuthenticated, isClient } = useAuth();
  const [value, setValue] = useState(location.pathname);

  // Get current path to highlight the correct tab
  React.useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        display: 'block' // Show on all devices
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={{
          height: '60px',
          '& .MuiBottomNavigationAction-root': {
            minWidth: '60px',
            padding: '6px 0',
            '& .MuiBottomNavigationAction-label': {
              opacity: 1,
              fontSize: '0.75rem',
              transition: 'font-size 0.2s, opacity 0.2s',
              '&.Mui-selected': {
                fontSize: '0.85rem'
              }
            }
          }
        }}
      >
        <BottomNavigationAction 
          label="Home" 
          value="/" 
          icon={<HomeIcon />} 
          component={Link} 
          to="/" 
          sx={{ 
            '& .MuiBottomNavigationAction-label': {
              opacity: 1 // Always show label
            }
          }}
        />
        
        {isAuthenticated() && !isClient() && (
          <BottomNavigationAction 
            label="Scan" 
            value="/scan" 
            icon={<ScanIcon />} 
            component={Link} 
            to="/scan" 
            sx={{ 
              '& .MuiBottomNavigationAction-label': {
                opacity: 1 // Always show label
              }
            }}
          />
        )}
        
        <BottomNavigationAction 
          label="News" 
          value="/news" 
          icon={<NewsIcon />} 
          component={Link} 
          to="/news" 
          sx={{ 
            '& .MuiBottomNavigationAction-label': {
              opacity: 1 // Always show label
            }
          }}
        />
        
        <BottomNavigationAction 
          label="Store" 
          value="/marketplace" 
          icon={<StoreIcon />} 
          component={Link} 
          to="/marketplace" 
          sx={{ 
            '& .MuiBottomNavigationAction-label': {
              opacity: 1 // Always show label
            }
          }}
        />
        
        {isAuthenticated() && !isClient() && (
          <BottomNavigationAction 
            label="Analytics" 
            value="/sex-ratio-analytics" 
            icon={<BarChartIcon />} 
            component={Link} 
            to="/sex-ratio-analytics" 
            sx={{ 
              '& .MuiBottomNavigationAction-label': {
                opacity: 1 // Always show label
              }
            }}
          />
        )}
        
        {isAuthenticated() && (
          <BottomNavigationAction 
            label="Profile" 
            value="/profile" 
            icon={<PersonIcon />} 
            component={Link} 
            to="/profile" 
            sx={{ 
              '& .MuiBottomNavigationAction-label': {
                opacity: 1 // Always show label
              }
            }}
          />
        )}
        
        <BottomNavigationAction 
          label="Settings" 
          value="/settings" 
          icon={<SettingsIcon />} 
          component={Link} 
          to="/settings" 
          sx={{ 
            '& .MuiBottomNavigationAction-label': {
              opacity: 1 // Always show label
            }
          }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomBar; 